import React, { Component } from 'react';
import { scoring_heads, penalties_heads, rosters_head, game_summary } from '~/tools/mll/headers';
import Penalties from '../RecapModules/Penalties';
import Rosters from '../RecapModules/Rosters';
import Scoring from '../RecapModules/Scoring';
import Summary from '../RecapModules/Summary';
import { combineNames } from '~/tools/mll/helpers';

import './RecapGame.css';

class RecapGame extends Component {
  state = {
    scoring: [],
    penalties: [],
    gameStats: [],
    rosters: []
  }

  initializeProps = () => {
    let { 
      gameinformation, 
      scoringsummary, 
      penaltysummary, 
      teamstats, 
      teamroster 
    } = this.props.api.gamescore.boxscore;
    this.index = 0;
    
    if (this.unmounted) return;

    this.setState({
      awayTeam: gameinformation.awayteam,
      homeTeam: gameinformation.hometeam,
      awayPlayers: combineNames(teamroster[0].player, 'firstname[0]', 'lastname'),
      homePlayers: combineNames(teamroster[1].player, 'firstname[0]', 'lastname'),
      scoring: combineNames(scoringsummary.goal, 'scorer.firstname[0]', 'scorer.lastname'),
      penalties: combineNames(penaltysummary.penalty, 'player.firstname[0]', 'player.lastname'),
      gameStats: teamstats,
      rosters: teamroster
    })
  }

  componentDidMount = () => {
    this.initializeProps()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.api !== prevProps.api) {
      this.initializeProps()
    }
  }

  componentWillUnmount = () => {
    this.unmounted = true;
  }

  findAssists = (assist, count) => {
    if (count === 1) this.asts = [];
    if (assist[`assist${count}`] !== undefined) {
      return this.asts.push(`${assist[`assist${count}`].firstname.slice(0, 1)}. ${assist[`assist${count}`].lastname}`)
      + this.findAssists(assist, count+1);
    } else {
      return this.asts;
    }
  }

  render() {
    const Assists = ({ data }) => {
      return <td>{data.assist1? this.findAssists(data, 1).replace(/[0-9]/g, '').replace(',', ', ') : 'N/A'}</td>
    }

    return (
      <div className='recap-body'>
        <div className='left-pane'>
          {this.state.scoring && <Scoring 
            headers={scoring_heads}
            scoring={this.state.scoring}
            Assists={Assists}
          />}
          {this.state.penalties && <Penalties 
            headers={penalties_heads}
            penalties={this.state.penalties}
          />}
          {this.state.rosters && <Rosters 
            headers={rosters_head}
            rosters={this.state.rosters}
            homeTeam={this.state.homeTeam}
            awayTeam={this.state.awayTeam}
            awayPlayers={this.state.awayPlayers}
            homePlayers={this.state.homePlayers}
          />}
        </div>
        <div className='right-pane'>
         {this.state.gameStats && <Summary 
            headers={game_summary}
            gameStats={this.state.gameStats}
            homeTeam={this.state.homeTeam}
            awayTeam={this.state.awayTeam}
          />}
        </div>
      </div>
    )
  }
}

export default RecapGame;